import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Button from '@components/uikit/Button/Button';

import style from './style.module.scss';

const propTypes = {
  children: PropTypes.any,
};

class ErrorBoundary extends Component {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={style.error}>
          <h1>Oops!</h1>
          <div className={style.errorDesc}>{'Something went wrong!'}</div>
          <div className={style.errorSubDesc}>
            Please check your link or click the button below. If you need assistance, please contact our
            support team at{' '}
            <a href="mailto:support@waites.net" className={style.errorPageSupportLink}>
              support@waites.net.
            </a>
          </div>
          <div className={style.errorAction}>
            <Button
              variant="text"
              type="primary"
              text="Home page"
              onClick={() => (window.location.href = window.location.origin)}
            />
          </div>
        </div>
      );
    }

    return this.props.children;
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }
}

ErrorBoundary.propTypes = propTypes;

export default ErrorBoundary;
